export default function Vision() {
  return (
    <section id="vision" className="relative py-16 sm:py-28 px-4 sm:px-6 overflow-hidden" style={{background: 'linear-gradient(135deg, #0d1f3c 0%, #152a52 50%, #111e3a 100%)'}}>
      {/* Gold vein lines */}
      <div className="absolute inset-0 opacity-[0.04]" style={{backgroundImage: 'linear-gradient(105deg, transparent 40%, #c9a227 41%, #c9a227 41.5%, transparent 42%), linear-gradient(75deg, transparent 60%, #c9a227 61%, #c9a227 61.3%, transparent 62%)', backgroundSize: '300px 300px'}}></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block bg-[#c9a227]/15 px-4 py-2 rounded-full mb-5 sm:mb-7 border border-[#c9a227]/30">
              <span className="text-sm sm:text-base font-medium text-[#c9a227] tracking-wide">Business Vision</span>
            </div>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-5 sm:mb-7 leading-[1.25] tracking-tight">
              신뢰, 정직, 완벽한 책임감
            </h2>
            <p className="text-base sm:text-lg text-white/75 leading-[1.9] mb-8 sm:mb-10 tracking-normal">
              홈&amp;그레이브는 전원주택과 산소 관리라는 두축을 통해 '프리미엄 공간 케어' 솔루션을 제공합니다. 디지털 데이터 기반의 신뢰와&nbsp; &nbsp;투명성으로 고객에게 완벽한 휴식과 정성을 동시에 전달합니다.
            </p>
            <div className="space-y-5">
              {[
                {
                  title: '디지털 데이터 기반 신뢰',
                  desc: '10년치 위성 사진 분석으로 전원주택 정원과 선산 지형을 과학적으로 파악하여 토지 분석 전문가로서의 권위 확보'
                },
                {
                  title: '프리미엄 서비스 가치',
                  desc: '드론 촬영과 GPS 측정으로 전원주택과 산소 관리 모두에서 투명성 극대화'
                },
                {
                  title: '감성적 가치 제공',
                  desc: '전원주택에서의 완벽한 휴식과 조상님께 예를 갖추는 정성을 동시에 실현'
                }
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-xl sm:text-2xl text-[#c9a227]"></i>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-bold text-white mb-1.5 tracking-tight">{item.title}</h3>
                    <p className="text-sm sm:text-base text-white/65 leading-[1.8]">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative mt-4 md:mt-0">
            <div className="aspect-[4/3] rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl border border-[#c9a227]/20">
              <img
                src="https://public.readdy.ai/ai/img_res/3e978e2d6c616fb341ec4493ae2d6471.jpg"
                alt="홈&그레이브 전문 팀"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 sm:-bottom-6 -right-2 sm:-right-6 text-white p-5 sm:p-8 rounded-xl sm:rounded-2xl shadow-xl border border-[#c9a227]/30" style={{background: 'linear-gradient(135deg, #1e3a6e, #152a52)'}}>
              <div className="text-3xl sm:text-5xl font-bold mb-1 sm:mb-2 text-[#c9a227]">98%</div>
              <div className="text-xs sm:text-sm tracking-wide text-white/80">고객 만족도</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
